import CaseSearchOmni from './CaseSearchOmni'

export default CaseSearchOmni
